  <mapfre-generic-information-template
    [headerImageURL]="'./assets/img/images/headers/cancel.png'"
    [backButtonUrl]="'/information'"
    [type]="'page'">
      <h1 class="information-title">{{ 'INFORMATION_CANCEL_1' | translate }}</h1>
      <div class="row information-content">
        <div class="col">
          <p class="information-par-margin">{{ 'INFORMATION_CANCEL_2' | translate }}</p>
         
        </div>
      </div>
  </mapfre-generic-information-template>